import React, { useContext } from 'react';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { useHistory } from "react-router-dom";
import MenuIcon from '@material-ui/icons/Menu';

import StudentContext from '../../context/student-context';
import { getIconDrawer } from '../../utils/helpers/icon/iconHelper';

const actions = [
    { icon: <img src={`${getIconDrawer().ic_menu_survey}`} />, name: 'Survey' },
    { icon: <img src={`${getIconDrawer().ic_menu_lc}`} />, name: 'Learning Resources' },
    { icon: <img src={`${getIconDrawer().ic_menu_feature_lc}`} />, name: 'Challenges' },
    { icon: <img src={`${getIconDrawer().ic_menu_reward}`} />, name: 'Shop' },
    { icon: <img src={`${getIconDrawer().ic_menu_news}`} />, name: 'News' },
    { icon: <img src={`${getIconDrawer().ic_menu_profile}`} />, name: 'Profile' },
    { icon: <img src={`${getIconDrawer().ic_menu_logout}`} />, name: 'Logout' },
];

export default function IslandMenu() {
    const [open, setOpen] = React.useState(false);
    const history = useHistory();
    const { logout } = useContext(StudentContext);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRoute = (param) => {
        switch (param) {
            case 'Survey':
                return history.push("/Survey");
            case 'Learning Resources':
                {
                    return history.push("/LearningContentCategories");
                }
            case 'Challenges':
                return history.push("/Challenge");
            case 'Shop':
                return history.push("/RewardShop");
            case 'News':
                return history.push("/News");
            case 'Profile':
                return history.push("/Profile");
            case 'Logout':
                logout();
                break;
        }
    }

    return (
        <SpeedDial
            ariaLabel="SpeedDial openIcon example"
            className="adventurelearn__menuIcon"
            icon={<MenuIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={"down"}
        >
            {actions.map((action) => (
                <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    tooltipOpen
                    onClick={() => handleRoute(action.name)}
                />
            ))}
        </SpeedDial>
    );
}